import { graphql } from 'gatsby'
import React from 'react'

interface SimpleBannerProps {
  block: {
    css_class_name: string
    settings: {
      margin_bottom: string
      css_class_name: string
      custom_css: string
    }
    image: string
    image_alt_text: string
    title: string
    text: string
    icon_position: 'Left' | 'Right'
  }
}

export const simpleBannerQuery = graphql`
  fragment SimpleBannerFragment on Block {
    settings {
      margin_bottom
      css_class_name
      custom_css
    }
    image
    image_alt_text
    title
    text
    icon_position
  }
`

const SimpleBanner = ({ block }: SimpleBannerProps) => {
  let direction = block.icon_position
    ? ` simple-banner--${block.icon_position.toLowerCase()}`
    : ''

  return (
    <section className={`block block__simple-banner ${block.css_class_name}`}>
      <div className="container">
        <div className={`banner-wr simple-banner${direction}`}>
          <div className="simple-banner__content">
            <h4>{block.title}</h4>
            <p>{block.text}</p>
          </div>
          <img
            src={block.image}
            alt={block.image_alt_text}
            className="simple-banner__icon"
          />
        </div>
      </div>
    </section>
  )
}

export default SimpleBanner
